import Routers from 'constants/routers';
import { useAuth } from '../../context/AuthContext';
import { Navigate } from 'react-router-dom';
import Loading from 'components/Loading';

interface RoleGuardProps {
  allowedRoles: string[];
  children: React.ReactNode;
}

const RoleGuard = ({ allowedRoles, children }: RoleGuardProps) => {
  const { user, isAuthenticated, isLoadingAuth  } = useAuth();

  if (isLoadingAuth) {
    return <Loading />;
  }

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />;
  }

  if (!allowedRoles.includes(user?.role)) {
    return <Navigate to={Routers.NotFound} replace />; 
  }

  return <>{children}</>;
};

export default RoleGuard;
